var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useMemo } from 'react';
import { Box, Button, IconButton, Typography, MenuItem, Grid, Dialog, DialogActions, DialogContent, DialogTitle, Tooltip } from '@mui/material';
import { MODOS, MENSAGENS } from '../../../../../utils';
import { ROUTES, FUNCIONALIDADES } from '../../../../../routes';
import { BoxBotoes } from '../../../../../components/form_box';
import Loading from '../../../../../components/loading';
import { useParams } from 'react-router-dom';
import { BotaoFechar, BotaoAuxiliar } from '../../../../../components/botoes';
import { InputDados } from '../../../../../components/input_dados';
import { ModeEditOutlined as ModeEditOutlinedIcon, DeleteOutline as DeleteOutlineIcon, Download as DownloadIcon, AttachFile as AttachFileIcon, } from '@mui/icons-material';
import GridComp from '../../../../../components/grid';
import { alterarComorbidade as alterarComorbidadeAPI, cadastrarComorbidade, excluirComorbidade, getTiposComorbidades, alterarDependencia as alterarDependenciaAPI, cadastrarDependencia, excluirDependencia, getTiposDependencias, getTiposTempoUso, STATUS_API, getReeducandoDependenciasComorbidades, baixarDependenciaArquivo, baixarComorbidadeArquivo, } from './services';
import { useAuth } from '../../../../../contexts/auth/AuthContext';
export var ReeducandosDependeciasComorbidades = function (props) {
    var getAcoesFuncionalidade = useAuth().getAcoesFuncionalidade;
    var AcoesFuncionalidade = useMemo(function () { return getAcoesFuncionalidade(FUNCIONALIDADES.REEDUCANDOS_DEPENDENCIAS_COMORBIDADES); }, [getAcoesFuncionalidade]);
    var _a = useState(true), loading = _a[0], setLoading = _a[1];
    var _b = useState(true), LoadingInicio = _b[0], setLoadingInicio = _b[1];
    var _c = useParams(), id = _c.id, modo = _c.modo;
    var _d = useState([]), ComorbidadesReeducando = _d[0], setComorbidadesReeducando = _d[1];
    var _e = useState([]), TiposComorbidadesDisponiveis = _e[0], setTiposComorbidadesDisponiveis = _e[1];
    var _f = useState(-1), TipoComorbidadeSelecionado = _f[0], setTipoComorbidadeSelecionado = _f[1];
    var _g = useState(), Observacao = _g[0], setObservacao = _g[1];
    var _h = useState(''), NomeArquivoOriginalComorbidade = _h[0], setNomeArquivoOriginalComorbidade = _h[1];
    var _j = useState(null), ArquivoSelecionadoComorbidade = _j[0], setArquivoSelecionadoComorbidade = _j[1];
    var _k = useState(false), PopupAbertoComorbidades = _k[0], setPopupAbertoComorbidades = _k[1];
    var _l = useState(), EditarIDComorbidades = _l[0], setEditarIDComorbidades = _l[1];
    var _m = useState(-1), EditarTipoComorbidadeSelecionado = _m[0], setEditarTipoComorbidadeSelecionado = _m[1];
    var _o = useState(), EditarObservacao = _o[0], setEditarObservacao = _o[1];
    var _p = useState([]), DependenciasReeducando = _p[0], setDependenciasReeducando = _p[1];
    var _q = useState([]), TiposDependenciasDisponiveis = _q[0], setTiposDependenciasDisponiveis = _q[1];
    var _r = useState(-1), TipoDependenciaSelecionado = _r[0], setTipoDependenciaSelecionado = _r[1];
    var _s = useState(-1), TipoTempoSelecionado = _s[0], setTipoTempoSelecionado = _s[1];
    var _t = useState(), TempoUso = _t[0], setTempoUso = _t[1];
    var _u = useState(false), RecaidaRecente = _u[0], setRecaidaRecente = _u[1];
    var _v = useState(''), NomeArquivoOriginal = _v[0], setNomeArquivoOriginal = _v[1];
    var _w = useState(null), ArquivoSelecionado = _w[0], setArquivoSelecionado = _w[1];
    var _x = useState(false), PopupAbertoDependencias = _x[0], setPopupAbertoDependencias = _x[1];
    var _y = useState(), EditarIDDependencias = _y[0], setEditarIDDependencias = _y[1];
    var _z = useState(-1), EditarTipoDependenciaSelecionado = _z[0], setEditarTipoDependenciaSelecionado = _z[1];
    var _0 = useState(-1), EditarTipoTempoSelecionado = _0[0], setEditarTipoTempoSelecionado = _0[1];
    var _1 = useState(), EditarTempoUso = _1[0], setEditarTempoUso = _1[1];
    var _2 = useState(true), EditarRecaidaRecente = _2[0], setEditarRecaidaRecente = _2[1];
    var setAbaAtiva = props.setAbaAtiva;
    var DESABILITAR_CAMPOS = modo == MODOS.VISUALIZAR || modo == MODOS.EXCLUIR;
    useEffect(function () {
        carregarDados();
        return function () { };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    var carregarDados = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a, TiposDependenciasAux, TiposComorbidadesAux, ReeducandoDadosAux, dependencias, comorbidades;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!id) return [3 /*break*/, 2];
                    return [4 /*yield*/, Promise.all([
                            getTiposDependencias(),
                            getTiposComorbidades(),
                            getReeducandoDependenciasComorbidades(id),
                        ])];
                case 1:
                    _a = _b.sent(), TiposDependenciasAux = _a[0], TiposComorbidadesAux = _a[1], ReeducandoDadosAux = _a[2];
                    if (TiposDependenciasAux.Status == STATUS_API.ERRO) {
                        alert(TiposDependenciasAux.Mensagem);
                        return [2 /*return*/];
                    }
                    else {
                        setTiposDependenciasDisponiveis(TiposDependenciasAux);
                    }
                    if (TiposComorbidadesAux.Status == STATUS_API.ERRO) {
                        alert(TiposComorbidadesAux.Mensagem);
                        return [2 /*return*/];
                    }
                    else {
                        setTiposComorbidadesDisponiveis(TiposComorbidadesAux);
                    }
                    if (ReeducandoDadosAux.Status == STATUS_API.ERRO) {
                        alert(ReeducandoDadosAux.Mensagem);
                        return [2 /*return*/];
                    }
                    else {
                        dependencias = ReeducandoDadosAux.dependencias, comorbidades = ReeducandoDadosAux.comorbidades;
                        setDependenciasReeducando(dependencias);
                        setComorbidadesReeducando(comorbidades);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    alert('ID do Colaborador não informado');
                    _b.label = 3;
                case 3:
                    setLoadingInicio(false);
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var validarDadosDependencias = function () {
        if (!TipoDependenciaSelecionado || TipoDependenciaSelecionado == -1) {
            alert("Tipo de Depend\u00EAncia ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        return true;
    };
    var validarDadosEditarDependencias = function () {
        if (!EditarTipoDependenciaSelecionado || EditarTipoDependenciaSelecionado == -1) {
            alert("Tipo de Depend\u00EAncia ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        return true;
    };
    var handleFileChangeDependencia = function (event) {
        var _a, _b;
        if (!((_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0]))
            return;
        var file = event.target.files[0];
        var fileName = file.name;
        var fileExtension = (_b = fileName.split('.').pop()) === null || _b === void 0 ? void 0 : _b.toLowerCase();
        if (fileExtension !== 'pdf') {
            alert('Selecione um arquivo do tipo PDF');
            event.target.value = '';
            return;
        }
        setArquivoSelecionado(file);
        setNomeArquivoOriginal(fileName);
    };
    var adicionarDependencia = function () { return __awaiter(void 0, void 0, void 0, function () {
        var FormDataAux, Resp, dependencias;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!validarDadosDependencias())
                        return [2 /*return*/];
                    setLoading(true);
                    FormDataAux = new FormData();
                    FormDataAux.append('tipo_dependencia_id', (_a = TipoDependenciaSelecionado === null || TipoDependenciaSelecionado === void 0 ? void 0 : TipoDependenciaSelecionado.toString()) !== null && _a !== void 0 ? _a : '');
                    if (TempoUso)
                        FormDataAux.append('tempo_uso', TempoUso);
                    if (TipoTempoSelecionado && TipoTempoSelecionado != -1) {
                        FormDataAux.append('tempo_uso_tipo', TipoTempoSelecionado.toString());
                    }
                    FormDataAux.append('recaida_recente', RecaidaRecente ? 'true' : 'false');
                    if (ArquivoSelecionado) {
                        FormDataAux.append('nome_arquivo_original', ArquivoSelecionado.name);
                        FormDataAux.append('arquivo', ArquivoSelecionado);
                    }
                    return [4 /*yield*/, cadastrarDependencia(FormDataAux, id !== null && id !== void 0 ? id : '')];
                case 1:
                    Resp = _b.sent();
                    if ((Resp === null || Resp === void 0 ? void 0 : Resp.Status) == 'OK') {
                        dependencias = Resp.dados.dependencias;
                        setDependenciasReeducando(dependencias !== null && dependencias !== void 0 ? dependencias : []);
                        limparSelecaoDependencias();
                    }
                    else {
                        alert(Resp.Mensagem);
                    }
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var alterarDependencia = function () { return __awaiter(void 0, void 0, void 0, function () {
        var Dados, Resp, DependenciasAtualizados;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!validarDadosEditarDependencias())
                        return [2 /*return*/];
                    setLoading(true);
                    Dados = {
                        tipo_dependencia_id: EditarTipoDependenciaSelecionado,
                        tempo_uso: EditarTempoUso ? Number.parseInt(EditarTempoUso) : null,
                        tempo_uso_tipo: EditarTipoTempoSelecionado,
                        recaida_recente: EditarRecaidaRecente,
                    };
                    return [4 /*yield*/, alterarDependenciaAPI(Dados, EditarIDDependencias ? EditarIDDependencias.toString() : '')];
                case 1:
                    Resp = _a.sent();
                    if ((Resp === null || Resp === void 0 ? void 0 : Resp.Status) == 'OK') {
                        DependenciasAtualizados = DependenciasReeducando.map(function (Item) {
                            if (Item.id == EditarIDDependencias) {
                                return __assign(__assign({}, Item), Dados);
                            }
                            else {
                                return Item;
                            }
                        });
                        setDependenciasReeducando(DependenciasAtualizados);
                        setPopupAbertoDependencias(false);
                        limparPopupDependencias();
                    }
                    else {
                        alert(Resp ? Resp.Mensagem : 'Erro ao executar a solicitação');
                    }
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleDeleteDependencia = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var Resp, DependenciasAtualizados;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!confirm(MENSAGENS.EXCLUIR_REGISTRO)) return [3 /*break*/, 2];
                    setLoading(true);
                    return [4 /*yield*/, excluirDependencia(id)];
                case 1:
                    Resp = _a.sent();
                    if ((Resp === null || Resp === void 0 ? void 0 : Resp.Status) == 'OK') {
                        DependenciasAtualizados = DependenciasReeducando.filter(function (Item) { return Item.id != +id; });
                        setDependenciasReeducando(DependenciasAtualizados);
                    }
                    else {
                        setLoading(false);
                        alert(Resp ? Resp.Mensagem : 'Erro ao executar a solicitação');
                    }
                    setLoading(false);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var limparSelecaoDependencias = function () {
        setTipoDependenciaSelecionado(-1);
        setRecaidaRecente(false);
        setTempoUso('');
        setTipoTempoSelecionado(-1);
        setArquivoSelecionado(null);
        setNomeArquivoOriginal('');
    };
    var handleDownloadDependencia = function (dependenciaId, nomeArquivo) { return __awaiter(void 0, void 0, void 0, function () {
        var Resposta, link;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, baixarDependenciaArquivo(dependenciaId.toString())];
                case 1:
                    Resposta = _a.sent();
                    if (Resposta.Status === STATUS_API.OK) {
                        link = document.createElement('a');
                        link.href = URL.createObjectURL(Resposta.dados);
                        link.download = nomeArquivo || 'documento-dependencia.pdf';
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        URL.revokeObjectURL(link.href);
                    }
                    else {
                        alert(Resposta.Mensagem || 'Erro ao baixar o documento.');
                    }
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var possuiDocumentoDependencia = function (row) { return Boolean((row === null || row === void 0 ? void 0 : row.nome_arquivo_original) || (row === null || row === void 0 ? void 0 : row.tem_arquivo)); };
    var limparPopupDependencias = function () {
        setEditarIDDependencias(undefined);
        setEditarTipoDependenciaSelecionado(-1);
        setEditarRecaidaRecente(false);
        setEditarTempoUso('');
        setEditarTipoTempoSelecionado(-1);
    };
    var COLUNAS_TERMOS_DEPENDENCIAS = [
        {
            field: 'tipo_dependencia_id',
            headerName: 'Tipo de Dependência',
            width: 250,
            valueGetter: function (_value, row) { var _a; return (_a = row.tipo_dependencia) === null || _a === void 0 ? void 0 : _a.nome; },
        },
        {
            field: 'tempo_uso',
            headerName: 'Tempo de Uso',
            width: 150,
        },
        {
            field: 'tempo_uso_tipo',
            headerName: 'Tipo de Tempo de Uso',
            width: 150,
        },
        {
            field: 'recaida_recente',
            headerName: 'Recaída Recente',
            width: 150,
            valueGetter: function (value) { return (value ? 'Sim' : 'Não'); },
        },
        {
            field: 'Opções',
            headerName: '',
            align: 'right',
            flex: 1,
            minWidth: 120,
            renderCell: function (params) { return (_jsxs(Box, __assign({ flex: 1, display: 'flex', justifyContent: 'flex-end' }, { children: [possuiDocumentoDependencia(params.row) && (_jsx(Box, __assign({ bgcolor: 'secondary.main', style: { borderRadius: '50%', width: 25, height: 25, margin: 4 } }, { children: _jsx(IconButton, __assign({ style: { padding: 0, margin: 0, paddingRight: 0, marginTop: -1 }, onClick: function () { var _a, _b, _c; return handleDownloadDependencia((_a = params.row) === null || _a === void 0 ? void 0 : _a.id, ((_b = params.row) === null || _b === void 0 ? void 0 : _b.nome_arquivo_original) || ((_c = params.row) === null || _c === void 0 ? void 0 : _c.nome_arquivo)); }, disabled: !AcoesFuncionalidade['VISUALIZAR'] && !AcoesFuncionalidade['ALTERAR'] }, { children: _jsx(DownloadIcon, { fontSize: 'medium', style: { color: 'white', marginBottom: 5, paddingBottom: 5 } }) })) }))), _jsx(Box, __assign({ bgcolor: 'primary.main', style: { borderRadius: '50%', width: 25, height: 25, margin: 4 } }, { children: _jsx(IconButton, __assign({ style: { padding: 0, margin: 0, paddingRight: 0, marginTop: -1 }, onClick: function () {
                                var _a;
                                abrirPopupDependencias((_a = params.row) === null || _a === void 0 ? void 0 : _a.id);
                            }, disabled: DESABILITAR_CAMPOS || !AcoesFuncionalidade['ALTERAR'] }, { children: _jsx(ModeEditOutlinedIcon, { fontSize: 'medium', style: { color: 'white', marginBottom: 5, paddingBottom: 5 } }) })) })), _jsx(Box, __assign({ bgcolor: 'error.main', style: { borderRadius: '50%', width: 25, height: 25, margin: 4 } }, { children: _jsx(IconButton, __assign({ style: { padding: 0, margin: 0, paddingRight: 0, marginTop: -1 }, onClick: function () { var _a; return handleDeleteDependencia((_a = params.row) === null || _a === void 0 ? void 0 : _a.id); }, disabled: DESABILITAR_CAMPOS || !AcoesFuncionalidade['EXCLUIR'] }, { children: _jsx(DeleteOutlineIcon, { fontSize: 'medium', style: { color: 'white', marginBottom: 5, paddingBottom: 5 } }) })) }))] }))); },
        },
    ];
    var abrirPopupDependencias = function (DependenciaID) { return __awaiter(void 0, void 0, void 0, function () {
        var DependenciaAux, id_1, tipo_dependencia_id, tempo_uso, tempo_uso_tipo, recaida_recente;
        return __generator(this, function (_a) {
            setLoading(true);
            DependenciaAux = DependenciasReeducando.find(function (Item) { return Item.id == +DependenciaID; });
            if (DependenciaAux) {
                id_1 = DependenciaAux.id, tipo_dependencia_id = DependenciaAux.tipo_dependencia_id, tempo_uso = DependenciaAux.tempo_uso, tempo_uso_tipo = DependenciaAux.tempo_uso_tipo, recaida_recente = DependenciaAux.recaida_recente;
                setEditarIDDependencias(id_1);
                setEditarTipoDependenciaSelecionado(tipo_dependencia_id);
                setEditarTempoUso(tempo_uso);
                setEditarTipoTempoSelecionado(tempo_uso_tipo);
                setEditarRecaidaRecente(recaida_recente);
            }
            setLoading(false);
            setPopupAbertoDependencias(true);
            return [2 /*return*/];
        });
    }); };
    var handleCloseDependencias = function () {
        if (confirm('Tem certeza que deseja sair?')) {
            setPopupAbertoDependencias(false);
        }
    };
    var validarDadosComorbidades = function () {
        if (!TipoComorbidadeSelecionado || TipoComorbidadeSelecionado == -1) {
            alert("Tipo de Comorbidade ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        return true;
    };
    var validarDadosEditarComorbidades = function () {
        if (!EditarTipoComorbidadeSelecionado || EditarTipoComorbidadeSelecionado == -1) {
            alert("Tipo de Comorbidade ".concat(MENSAGENS.PREENCHIMENTO_OBRIGATORIO));
            return false;
        }
        return true;
    };
    var handleFileChangeComorbidade = function (event) {
        var _a, _b;
        if (!((_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0]))
            return;
        var file = event.target.files[0];
        var fileName = file.name;
        var fileExtension = (_b = fileName.split('.').pop()) === null || _b === void 0 ? void 0 : _b.toLowerCase();
        if (fileExtension !== 'pdf') {
            alert('Selecione um arquivo do tipo PDF');
            event.target.value = '';
            return;
        }
        setArquivoSelecionadoComorbidade(file);
        setNomeArquivoOriginalComorbidade(fileName);
    };
    var adicionarComorbidade = function () { return __awaiter(void 0, void 0, void 0, function () {
        var FormDataAux, Resp, comorbidades;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!validarDadosComorbidades())
                        return [2 /*return*/];
                    setLoading(true);
                    FormDataAux = new FormData();
                    FormDataAux.append('tipo_comorbidade_id', (_a = TipoComorbidadeSelecionado === null || TipoComorbidadeSelecionado === void 0 ? void 0 : TipoComorbidadeSelecionado.toString()) !== null && _a !== void 0 ? _a : '');
                    if (Observacao)
                        FormDataAux.append('descricao', Observacao);
                    if (ArquivoSelecionadoComorbidade) {
                        FormDataAux.append('nome_arquivo_original', ArquivoSelecionadoComorbidade.name);
                        FormDataAux.append('arquivo', ArquivoSelecionadoComorbidade);
                    }
                    return [4 /*yield*/, cadastrarComorbidade(FormDataAux, id !== null && id !== void 0 ? id : '')];
                case 1:
                    Resp = _b.sent();
                    if ((Resp === null || Resp === void 0 ? void 0 : Resp.Status) == 'OK') {
                        comorbidades = Resp.dados.comorbidades;
                        setComorbidadesReeducando(comorbidades !== null && comorbidades !== void 0 ? comorbidades : []);
                        limparSelecao();
                    }
                    else {
                        alert(Resp.Mensagem);
                    }
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var alterarComorbidade = function () { return __awaiter(void 0, void 0, void 0, function () {
        var Dados, Resp, ComorbidadesAtualizados;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!validarDadosEditarComorbidades())
                        return [2 /*return*/];
                    setLoading(true);
                    Dados = {
                        tipo_comorbidade_id: EditarTipoComorbidadeSelecionado,
                        descricao: EditarObservacao,
                    };
                    return [4 /*yield*/, alterarComorbidadeAPI(Dados, EditarIDComorbidades ? EditarIDComorbidades.toString() : '')];
                case 1:
                    Resp = _a.sent();
                    if ((Resp === null || Resp === void 0 ? void 0 : Resp.Status) == 'OK') {
                        ComorbidadesAtualizados = ComorbidadesReeducando.map(function (Item) {
                            if (Item.id == EditarIDComorbidades) {
                                return __assign(__assign({}, Item), Dados);
                            }
                            else {
                                return Item;
                            }
                        });
                        setComorbidadesReeducando(ComorbidadesAtualizados);
                        setPopupAbertoComorbidades(false);
                        limparPopup();
                    }
                    else {
                        alert(Resp ? Resp.Mensagem : 'Erro ao executar a solicitação');
                    }
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleDelete = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var Resp, ComorbidadesAtualizados;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!confirm(MENSAGENS.EXCLUIR_REGISTRO)) return [3 /*break*/, 2];
                    setLoading(true);
                    return [4 /*yield*/, excluirComorbidade(id)];
                case 1:
                    Resp = _a.sent();
                    if ((Resp === null || Resp === void 0 ? void 0 : Resp.Status) == 'OK') {
                        ComorbidadesAtualizados = ComorbidadesReeducando.filter(function (Item) { return Item.id != +id; });
                        setComorbidadesReeducando(ComorbidadesAtualizados);
                    }
                    else {
                        setLoading(false);
                        alert(Resp ? Resp.Mensagem : 'Erro ao executar a solicitação');
                    }
                    setLoading(false);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var handleDownloadComorbidade = function (comorbidadeId, nomeArquivo) { return __awaiter(void 0, void 0, void 0, function () {
        var Resposta, link;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoading(true);
                    return [4 /*yield*/, baixarComorbidadeArquivo(comorbidadeId.toString())];
                case 1:
                    Resposta = _a.sent();
                    if (Resposta.Status === STATUS_API.OK) {
                        link = document.createElement('a');
                        link.href = URL.createObjectURL(Resposta.dados);
                        link.download = nomeArquivo || 'documento-comorbidade.pdf';
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        URL.revokeObjectURL(link.href);
                    }
                    else {
                        alert(Resposta.Mensagem || 'Erro ao baixar o documento.');
                    }
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var possuiDocumentoComorbidade = function (row) { return Boolean((row === null || row === void 0 ? void 0 : row.nome_arquivo_original) || (row === null || row === void 0 ? void 0 : row.tem_arquivo)); };
    var limparSelecao = function () {
        setTipoComorbidadeSelecionado(-1);
        setObservacao('');
        setArquivoSelecionadoComorbidade(null);
        setNomeArquivoOriginalComorbidade('');
    };
    var limparPopup = function () {
        setEditarIDComorbidades(undefined);
        setEditarTipoComorbidadeSelecionado(-1);
        setEditarObservacao('');
    };
    var COLUNAS_TERMOS = [
        {
            field: 'tipo_comorbidade_id',
            headerName: 'Tipo de Comorbidade',
            width: 250,
            valueGetter: function (_value, row) { var _a; return (_a = row.tipo_comorbidade) === null || _a === void 0 ? void 0 : _a.nome; },
        },
        {
            field: 'descricao',
            headerName: 'Descrição',
            width: 500,
        },
        {
            field: 'Opções',
            headerName: '',
            align: 'right',
            flex: 1,
            minWidth: 120,
            renderCell: function (params) { return (_jsxs(Box, __assign({ flex: 1, display: 'flex', justifyContent: 'flex-end' }, { children: [possuiDocumentoComorbidade(params.row) && (_jsx(Box, __assign({ bgcolor: 'secondary.main', style: { borderRadius: '50%', width: 25, height: 25, margin: 4 } }, { children: _jsx(IconButton, __assign({ style: { padding: 0, margin: 0, paddingRight: 0, marginTop: -1 }, onClick: function () { var _a, _b, _c; return handleDownloadComorbidade((_a = params.row) === null || _a === void 0 ? void 0 : _a.id, ((_b = params.row) === null || _b === void 0 ? void 0 : _b.nome_arquivo_original) || ((_c = params.row) === null || _c === void 0 ? void 0 : _c.nome_arquivo)); }, disabled: !AcoesFuncionalidade['VISUALIZAR'] && !AcoesFuncionalidade['ALTERAR'] }, { children: _jsx(DownloadIcon, { fontSize: 'medium', style: { color: 'white', marginBottom: 5, paddingBottom: 5 } }) })) }))), _jsx(Box, __assign({ bgcolor: 'primary.main', style: { borderRadius: '50%', width: 25, height: 25, margin: 4 } }, { children: _jsx(IconButton, __assign({ style: { padding: 0, margin: 0, paddingRight: 0, marginTop: -1 }, onClick: function () {
                                var _a;
                                abrirPopup((_a = params.row) === null || _a === void 0 ? void 0 : _a.id);
                            }, disabled: DESABILITAR_CAMPOS || !AcoesFuncionalidade['ALTERAR'] }, { children: _jsx(ModeEditOutlinedIcon, { fontSize: 'medium', style: { color: 'white', marginBottom: 5, paddingBottom: 5 } }) })) })), _jsx(Box, __assign({ bgcolor: 'error.main', style: { borderRadius: '50%', width: 25, height: 25, margin: 4 } }, { children: _jsx(IconButton, __assign({ style: { padding: 0, margin: 0, paddingRight: 0, marginTop: -1 }, onClick: function () { var _a; return handleDelete((_a = params.row) === null || _a === void 0 ? void 0 : _a.id); }, disabled: DESABILITAR_CAMPOS || !AcoesFuncionalidade['EXCLUIR'] }, { children: _jsx(DeleteOutlineIcon, { fontSize: 'medium', style: { color: 'white', marginBottom: 5, paddingBottom: 5 } }) })) }))] }))); },
        },
    ];
    var abrirPopup = function (ComorbidadeID) { return __awaiter(void 0, void 0, void 0, function () {
        var ComorbidadeAux, id_2, tipo_comorbidade_id, descricao;
        return __generator(this, function (_a) {
            setLoading(true);
            ComorbidadeAux = ComorbidadesReeducando.find(function (Item) { return Item.id == +ComorbidadeID; });
            if (ComorbidadeAux) {
                id_2 = ComorbidadeAux.id, tipo_comorbidade_id = ComorbidadeAux.tipo_comorbidade_id, descricao = ComorbidadeAux.descricao;
                setEditarIDComorbidades(id_2);
                setEditarTipoComorbidadeSelecionado(tipo_comorbidade_id);
                setEditarObservacao(descricao);
            }
            setLoading(false);
            setPopupAbertoComorbidades(true);
            return [2 /*return*/];
        });
    }); };
    var handleClose = function () {
        if (confirm('Tem certeza que deseja sair?')) {
            setPopupAbertoComorbidades(false);
        }
    };
    return (_jsx(_Fragment, { children: !LoadingInicio && (_jsxs(_Fragment, { children: [_jsxs(Box, __assign({ mt: 5 }, { children: [_jsx(Typography, __assign({ variant: 'h6', gutterBottom: true }, { children: "Depend\u00EAncia" })), _jsxs(Grid, __assign({ container: true, spacing: 2 }, { children: [_jsx(Grid, __assign({ item: true, xs: 12, sm: 2 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'tipo-dependencia', label: 'Tipo de Depend\u00EAncia', placeholder: 'Tipo de Depend\u00EAncia', value: TipoDependenciaSelecionado, onChange: function (event) {
                                            setTipoDependenciaSelecionado(event.target.value);
                                        }, disabled: DESABILITAR_CAMPOS }, { children: [_jsx(MenuItem, __assign({ value: -1 }, { children: _jsx("em", { children: "Selecione" }) })), TiposDependenciasDisponiveis === null || TiposDependenciasDisponiveis === void 0 ? void 0 : TiposDependenciasDisponiveis.map(function (item) { return (_jsx(MenuItem, __assign({ value: item.id }, { children: item.nome }), item.id)); })] })) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 2 }, { children: _jsx(InputDados, { id: 'tempo-uso', label: 'Tempo de Uso', mask: '9999', value: TempoUso, onChange: function (event) { return setTempoUso(event.target.value); }, disabled: DESABILITAR_CAMPOS }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 2 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'tipo-tempo-uso', label: 'Tipo de Tempo de Uso', placeholder: 'Tipo de Tempo de Uso', value: TipoTempoSelecionado, onChange: function (event) {
                                            setTipoTempoSelecionado(event.target.value);
                                        }, disabled: DESABILITAR_CAMPOS }, { children: [_jsx(MenuItem, __assign({ value: -1 }, { children: _jsx("em", { children: "Selecione" }) })), getTiposTempoUso().map(function (item) { return (_jsx(MenuItem, __assign({ value: item.id }, { children: item.nome }), item.id)); })] })) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 2 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'recaida-recente', label: 'Reca\u00EDda Recente', placeholder: 'Reca\u00EDda Recente', value: RecaidaRecente, onChange: function (event) {
                                            var Valor = event.target.value;
                                            setRecaidaRecente(Valor == undefined ? undefined : Valor == 'true');
                                        }, disabled: DESABILITAR_CAMPOS }, { children: [_jsx(MenuItem, __assign({ value: undefined }, { children: _jsx("em", { children: "Selecione" }) })), _jsx(MenuItem, __assign({ value: 'true' }, { children: "Sim" })), _jsx(MenuItem, __assign({ value: 'false' }, { children: "N\u00E3o" }))] })) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 6 }, { children: _jsxs(Box, __assign({ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }, { children: [NomeArquivoOriginal && (_jsx(Tooltip, __assign({ title: NomeArquivoOriginal, placement: 'top', arrow: true }, { children: _jsxs(Typography, __assign({ variant: 'caption', sx: {
                                                        mb: 0.5,
                                                        px: 1,
                                                        py: 0.3,
                                                        backgroundColor: 'rgba(0, 0, 0, 0.08)',
                                                        borderRadius: 1,
                                                        maxWidth: 300,
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: 0.5,
                                                    } }, { children: [_jsx(AttachFileIcon, { sx: { fontSize: 14 } }), NomeArquivoOriginal] })) }))), _jsxs(Box, __assign({ display: 'flex', alignItems: 'center', gap: 1 }, { children: [_jsx("input", { accept: 'application/pdf', style: { display: 'none' }, id: 'arquivo-dependencia-upload', type: 'file', onChange: handleFileChangeDependencia, disabled: DESABILITAR_CAMPOS }), _jsx("label", __assign({ htmlFor: 'arquivo-dependencia-upload' }, { children: _jsx(Button, __assign({ variant: 'outlined', component: 'span', disabled: DESABILITAR_CAMPOS }, { children: "Selecionar Documento" })) })), NomeArquivoOriginal && (_jsx(Button, __assign({ variant: 'outlined', color: 'error', size: 'small', onClick: function () {
                                                            setArquivoSelecionado(null);
                                                            setNomeArquivoOriginal('');
                                                            var input = document.getElementById('arquivo-dependencia-upload');
                                                            if (input)
                                                                input.value = '';
                                                        }, disabled: DESABILITAR_CAMPOS }, { children: "Remover" })))] }))] })) })), _jsxs(Grid, __assign({ item: true, xs: 12, sm: 12 }, { children: [_jsx(BotaoAuxiliar, __assign({ onClick: limparSelecaoDependencias, backgroundColor: 'error.main', disabled: DESABILITAR_CAMPOS }, { children: "Limpar" })), _jsx(BotaoAuxiliar, __assign({ sx: { ml: 1 }, onClick: adicionarDependencia, backgroundColor: 'principal.main', disabled: DESABILITAR_CAMPOS || !AcoesFuncionalidade['CADASTRAR'] }, { children: "Adicionar" }))] }))] })), _jsx(Box, __assign({ mt: 8 }, { children: _jsx(GridComp, { rows: DependenciasReeducando, columns: COLUNAS_TERMOS_DEPENDENCIAS, loading: loading, paginationMode: 'client', onPaginationModelChange: function () { } }) }))] })), _jsxs(Box, __assign({ mt: 5 }, { children: [_jsx(Typography, __assign({ variant: 'h6', gutterBottom: true }, { children: "Comorbidade" })), _jsxs(Grid, __assign({ container: true, spacing: 2 }, { children: [_jsx(Grid, __assign({ item: true, xs: 12, sm: 12 }, { children: _jsx(Grid, __assign({ item: true, xs: 12, sm: 2 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'tipo-comorbidade', label: 'Tipo de Comorbidade', placeholder: 'Tipo de Comorbidade', value: TipoComorbidadeSelecionado, onChange: function (event) {
                                                setTipoComorbidadeSelecionado(event.target.value);
                                            }, disabled: DESABILITAR_CAMPOS }, { children: [_jsx(MenuItem, __assign({ value: -1 }, { children: _jsx("em", { children: "Selecione" }) })), TiposComorbidadesDisponiveis === null || TiposComorbidadesDisponiveis === void 0 ? void 0 : TiposComorbidadesDisponiveis.map(function (item) { return (_jsx(MenuItem, __assign({ value: item.id }, { children: item.nome }), item.id)); })] })) })) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 8 }, { children: _jsx(InputDados, { id: 'observacao', label: 'Comorbidade', value: Observacao, onChange: function (event) { return setObservacao(event.target.value); }, multiline: true, maxRows: 4, disabled: DESABILITAR_CAMPOS }) })), _jsx(Grid, __assign({ item: true, xs: 12, sm: 6 }, { children: _jsxs(Box, __assign({ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }, { children: [NomeArquivoOriginalComorbidade && (_jsx(Tooltip, __assign({ title: NomeArquivoOriginalComorbidade, placement: 'top', arrow: true }, { children: _jsxs(Typography, __assign({ variant: 'caption', sx: {
                                                        mb: 0.5,
                                                        px: 1,
                                                        py: 0.3,
                                                        backgroundColor: 'rgba(0, 0, 0, 0.08)',
                                                        borderRadius: 1,
                                                        maxWidth: 300,
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        whiteSpace: 'nowrap',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: 0.5,
                                                    } }, { children: [_jsx(AttachFileIcon, { sx: { fontSize: 14 } }), NomeArquivoOriginalComorbidade] })) }))), _jsxs(Box, __assign({ display: 'flex', alignItems: 'center', gap: 1 }, { children: [_jsx("input", { accept: 'application/pdf', style: { display: 'none' }, id: 'arquivo-comorbidade-upload', type: 'file', onChange: handleFileChangeComorbidade, disabled: DESABILITAR_CAMPOS }), _jsx("label", __assign({ htmlFor: 'arquivo-comorbidade-upload' }, { children: _jsx(Button, __assign({ variant: 'outlined', component: 'span', disabled: DESABILITAR_CAMPOS }, { children: "Selecionar Documento" })) })), NomeArquivoOriginalComorbidade && (_jsx(Button, __assign({ variant: 'outlined', color: 'error', size: 'small', onClick: function () {
                                                            setArquivoSelecionadoComorbidade(null);
                                                            setNomeArquivoOriginalComorbidade('');
                                                            var input = document.getElementById('arquivo-comorbidade-upload');
                                                            if (input)
                                                                input.value = '';
                                                        }, disabled: DESABILITAR_CAMPOS }, { children: "Remover" })))] }))] })) })), _jsxs(Grid, __assign({ item: true, xs: 12, sm: 12 }, { children: [_jsx(BotaoAuxiliar, __assign({ onClick: limparSelecao, backgroundColor: 'error.main', disabled: DESABILITAR_CAMPOS }, { children: "Limpar" })), _jsx(BotaoAuxiliar, __assign({ sx: { ml: 1 }, onClick: adicionarComorbidade, backgroundColor: 'principal.main', disabled: DESABILITAR_CAMPOS || !AcoesFuncionalidade['CADASTRAR'] }, { children: "Adicionar" }))] }))] })), _jsx(Box, __assign({ mt: 8 }, { children: _jsx(GridComp, { rows: ComorbidadesReeducando, columns: COLUNAS_TERMOS, loading: loading, paginationMode: 'client', onPaginationModelChange: function () { } }) })), _jsxs(BoxBotoes, __assign({ sx: { marginTop: 10 } }, { children: [_jsx(BotaoAuxiliar, __assign({ backgroundColor: 'terceary.main', onClick: function () { return setAbaAtiva(5); } }, { children: "Voltar" })), _jsx(BotaoFechar, { modo: modo, pagina: ROUTES.REEDUCANDOS })] }))] })), _jsxs(Dialog, __assign({ open: PopupAbertoDependencias, onClose: handleCloseDependencias, maxWidth: 'sm', fullWidth: true }, { children: [_jsx(DialogTitle, { children: "Editar Depend\u00EAncia" }), _jsxs(DialogContent, __assign({ style: { margin: 5, padding: 10 } }, { children: [_jsx(Box, __assign({ mb: 2, mt: 2 }, { children: _jsx(InputDados, { id: 'id', label: 'ID', value: EditarIDDependencias, disabled: true }) })), _jsx(Box, __assign({ mb: 2 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'editar-tipo-dependencia', label: 'Tipo de Depend\u00EAncia', placeholder: 'Tipo de Depend\u00EAncia', value: EditarTipoDependenciaSelecionado, onChange: function (event) {
                                            setEditarTipoDependenciaSelecionado(event.target.value);
                                        }, disabled: DESABILITAR_CAMPOS }, { children: [_jsx(MenuItem, __assign({ value: -1 }, { children: _jsx("em", { children: "Selecione" }) })), TiposDependenciasDisponiveis === null || TiposDependenciasDisponiveis === void 0 ? void 0 : TiposDependenciasDisponiveis.map(function (item) { return (_jsx(MenuItem, __assign({ value: item.id }, { children: item.nome }), item.id)); })] })) })), _jsx(Box, __assign({ mb: 2 }, { children: _jsx(InputDados, { id: 'editar-tempo-uso', label: 'Tempo de Uso', mask: '9999', value: EditarTempoUso, onChange: function (event) { return setEditarTempoUso(event.target.value); }, disabled: DESABILITAR_CAMPOS }) })), _jsx(Box, __assign({ mb: 2 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'editar-tipo-tempo-uso', label: 'Tipo de Tempo de Uso', placeholder: 'Tipo de Tempo de Uso', value: EditarTipoTempoSelecionado, onChange: function (event) {
                                            setEditarTipoTempoSelecionado(event.target.value);
                                        }, disabled: DESABILITAR_CAMPOS }, { children: [_jsx(MenuItem, __assign({ value: -1 }, { children: _jsx("em", { children: "Selecione" }) })), getTiposTempoUso().map(function (item) { return (_jsx(MenuItem, __assign({ value: item.id }, { children: item.nome }), item.id)); })] })) })), _jsx(Box, __assign({ mb: 2 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'editar-recaida-recente', label: 'Reca\u00EDda Recente', placeholder: 'Reca\u00EDda Recente', value: EditarRecaidaRecente, onChange: function (event) {
                                            var Valor = event.target.value;
                                            setEditarRecaidaRecente(Valor == undefined ? undefined : Valor == 'true');
                                        }, disabled: DESABILITAR_CAMPOS }, { children: [_jsx(MenuItem, __assign({ value: undefined }, { children: _jsx("em", { children: "Selecione" }) })), _jsx(MenuItem, __assign({ value: 'true' }, { children: "Sim" })), _jsx(MenuItem, __assign({ value: 'false' }, { children: "N\u00E3o" }))] })) }))] })), _jsxs(DialogActions, __assign({ style: { padding: 20 } }, { children: [_jsx(Button, __assign({ onClick: handleCloseDependencias }, { children: "Cancelar" })), _jsx(Button, __assign({ onClick: alterarDependencia, variant: 'contained', color: 'primary' }, { children: "Salvar" }))] }))] })), _jsxs(Dialog, __assign({ open: PopupAbertoComorbidades, onClose: handleClose, maxWidth: 'sm', fullWidth: true }, { children: [_jsx(DialogTitle, { children: "Editar Comorbidade" }), _jsxs(DialogContent, __assign({ style: { margin: 5, padding: 10 } }, { children: [_jsx(Box, __assign({ mb: 2, mt: 2 }, { children: _jsx(InputDados, { id: 'id', label: 'ID', value: EditarIDComorbidades, disabled: true }) })), _jsx(Box, __assign({ mb: 2 }, { children: _jsxs(InputDados, __assign({ select: true, id: 'editar-tipo-comorbidade', label: 'Tipo de Comorbidade', placeholder: 'Tipo de Comorbidade', value: EditarTipoComorbidadeSelecionado, onChange: function (event) {
                                            setEditarTipoComorbidadeSelecionado(event.target.value);
                                        }, disabled: DESABILITAR_CAMPOS }, { children: [_jsx(MenuItem, __assign({ value: -1 }, { children: _jsx("em", { children: "Selecione" }) })), TiposComorbidadesDisponiveis === null || TiposComorbidadesDisponiveis === void 0 ? void 0 : TiposComorbidadesDisponiveis.map(function (item) { return (_jsx(MenuItem, __assign({ value: item.id }, { children: item.nome }), item.id)); })] })) })), _jsx(Box, __assign({ mb: 2 }, { children: _jsx(InputDados, { id: 'editar-observacao', label: 'Comorbidade', value: EditarObservacao, onChange: function (event) { return setEditarObservacao(event.target.value); }, multiline: true, maxRows: 4, disabled: DESABILITAR_CAMPOS }) }))] })), _jsxs(DialogActions, __assign({ style: { padding: 20 } }, { children: [_jsx(Button, __assign({ onClick: handleClose }, { children: "Cancelar" })), _jsx(Button, __assign({ onClick: alterarComorbidade, variant: 'contained', color: 'primary' }, { children: "Salvar" }))] }))] })), loading && _jsx(Loading, {})] })) }));
};
export default ReeducandosDependeciasComorbidades;
